import { observable, action, makeObservable } from 'mobx';
import { InputType, ISelectValueType, ValueType } from './types';

export class BooleanInput implements InputType {
  dataType: 'boolean';

  label: string;

  placeholder?: string;

  tag: string;

  @observable value: boolean | undefined | null;

  @observable selectorValue: ValueType<ISelectValueType> | undefined;

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: InputType) {
    if (dataType !== 'boolean')
      throw Error(
        `Type mismatch. Type must be of "boolean", instead saw "${dataType}"`,
      );
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null); // set initial value
  }

  @action
  onChange = (v: boolean | undefined | null) => {
    this.value = v;
  };

  @action
  clearValue = () => {
    this.value = null;
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
